import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebase'

const requireAuth = (to, from, next) => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    unsubscribe();
    if (user) {
      next();
    } else {
      next(`/${to.params.lang || 'en'}`);
    }
  });
};

const routes = [{
  path: '/:lang(en|cn)?',
  children: [
    {
      path: '',
      name: 'Home',
      component: () => import('@/views/Home')
    },
    {
      path: 'leaderboard',
      name: 'Leaderboard',
      component: () => import('@/views/Leaderboard')
    },
    {
      path: 'leaderboard/bg',
      name: 'LeaderboardWithBg',
      component: () => import('@/views/Leaderboard'),
      props: { displayBg: true }
    },
    {
      path: 'leaderboard/title/bg',
      name: 'LeaderboardWithTitleAndBg',
      component: () => import('@/views/Leaderboard'),
      props: { displayTitle: false, displayBg: true }
    },
    {
      path: 'leaderboard/title',
      name: 'LeaderboardWithTitle',
      component: () => import('@/views/Leaderboard'),
      props: { displayTitle: false }
    },
    {
      path: 'leaderboard/43',
      name: 'LeaderboardSmall',
      component: () => import('@/views/Leaderboard43'),
      props: { displayTitle: false }
    },
    {
      path: 'leaderboard/43/bg',
      name: 'LeaderboardSmallWithBg',
      component: () => import('@/views/Leaderboard43'),
      props: { displayTitle: false, displayBg: true }
    },
    {
      path: 'team/:id',
      name: 'TeamOverlay',
      component: () => import('@/views/TeamOverlay'),
      props: true
    },
    {
      path: 'specs',
      name: 'SpecSummary',
      component: () => import('@/views/SpecSummary')
    },
    {
      path: 'specs/total',
      name: 'TotalSpecs',
      component: () => import('@/views/TotalSpecs')
    },
    {
      path: 'specs/total/broadcast',
      name: 'TotalSpecsGrid',
      component: () => import('@/views/TotalSpecs'),
      props: { gridView: true, showNumbers: false }
    },
    {
      path: 'specs/total/broadcast/numbers',
      name: 'TotalSpecsGridNumbers',
      component: () => import('@/views/TotalSpecs'),
      props: { gridView: true, showNumbers: true }
    },
    {
      path: 'specs/bans',
      name: 'SpecBans',
      component: () => import('@/views/SpecBans')
    },
    {
      path: 'specs/bans/broadcast',
      name: 'SpecBansBroadcast',
      component: () => import('@/views/SpecBans'),
      props: { broadcastView: true }
    },
    {
      path: 'keys/dungeon',
      name: 'DungeonGroups',
      component: () => import('@/views/DungeonGroups')
    },
    {
      path: 'keys/dungeon/season',
      name: 'DungeonGroupsLeaderboard',
      component: () => import('@/views/DungeonGroupsLeaderboard')
    },
    {
      path: 'admin/dungeon-splits',
      name: 'DungeonSplits',
      component: () => import('@/views/DungeonSplits'),
      beforeEnter: requireAuth
    },
    {
      path: 'admin/teams',
      name: 'TeamController',
      component: () => import('@/views/TeamController'),
      beforeEnter: requireAuth
    },
    {
      path: 'admin/active-dungeons',
      name: 'ActiveDungeonController',
      component: () => import('@/views/ActiveDungeonController'),
      beforeEnter: requireAuth
    }
  ]
}]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
